import {
  computeHasHctCaiFeeParcels,
  computeHasHctHatPalletFeeParcels,
  computeOneHctPalletFee,
} from '@g/order-create/fee/hctFee'

export const getters = {
  hasHctHatPalletFeeParcels (state, getters) {
    return computeHasHctHatPalletFeeParcels({
      parcels: state.createPrepare?.parcels,
    })
  },
  hasHctCaiFeeParcels (state, getters) {
    return computeHasHctCaiFeeParcels({
      parcels: state.createPrepare?.parcels,
      hasHctHatPalletFeeParcels: getters.hasHctHatPalletFeeParcels,
      isBizParcel: state.createPrepare?.isBizParcel,
      hasFurniture: getters.hasFurniture,
    })
  },
  oneHctPalletFee (state, getters) {
    return computeOneHctPalletFee({
      addrInfo: state.currAddrInfo,
      hctCitiesPalletFee: state.createPrepare?.hctCitiesPalletFee,
    })
  },
}
